
import './bootstrap.css';
//import 'rc-tooltip/assets/bootstrap_white.css';
import React from 'react';
import Tooltip from 'rc-tooltip';
import Slider, { Range } from 'rc-slider';
import {  Input } from 'reactstrap';

const Handle = Slider.Handle;

const fundingHandle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value}M`}
      visible={dragging}
      placement="top"
      key={index}
      style={{ zIndex: 5000 }}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};
const employeeHandle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value}`}
      visible={dragging}
      placement="top"
      key={index}
      style={{ zIndex: 5000 }}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};
const valuationHandle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value / 1000000}M`}
      visible={dragging}
      placement="top"
      key={index}
      style={{ zIndex: 5000 }}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};
const growthHandle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value}%`}
      visible={dragging}
      placement="top"
      key={index}
      style={{ zIndex: 5000 }}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const openingsHandle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value}`}
      visible={dragging}
      placement="top"
      key={index}
      style={{ zIndex: 5000 }}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const wrapperStyle = { width: '90%', margin: '0px 13px' };

export default class CustomSlider extends React.Component {
  constructor(props) {
    super(props)
    const initialValue = props.value || [props.minVal, props.maxVal];

    this.state = {
      value: initialValue,
      minVal: initialValue[0],
      maxVal: initialValue[1],
      disabled: props.disabled
    };
  }
  componentDidUpdate(prevProps) {
    // Handle refresh prop
    if (this.props.refresh && !prevProps.refresh) {
      this.setState({
        value: [this.props.minVal, this.props.maxVal],
        minVal: this.props.minVal,
        maxVal: this.props.maxVal
      });
    }
    // Update when value prop changes (from URL)
    else if (this.props.value && JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value)) {
      this.setState({
        value: this.props.value,
        minVal: this.props.value[0],
        maxVal: this.props.value[1]
      });
    }
  }
  setMin = e => {
    const val = e.target.value === '' ? this.props.minVal : parseInt(e.target.value);
    if (!isNaN(val)) {
      const newValue = [Math.max(val, this.props.minVal), Math.min(this.state.value[1], this.props.maxVal)];
      this.setState({ 
        minVal: newValue[0],
        value: newValue 
      }, () => {
        this.props.onChange(newValue);
      });
    }
  };

  setMax = e => {
    const val = e.target.value === '' ? this.props.maxVal : parseInt(e.target.value);
    if (!isNaN(val)) {
      const newValue = [Math.max(this.state.value[0], this.props.minVal), Math.min(val, this.props.maxVal)];
      this.setState({ 
        maxVal: newValue[1],
        value: newValue 
      }, () => {
        this.props.onChange(newValue);
      });
    }
  };

  setValue = value => {
    this.setState({ 
      value,
      minVal: value[0],
      maxVal: value[1]
    }, () => {
      this.props.onChange(value);
      if (this.props.changeRefresh) {
        this.props.changeRefresh();
      }
    });
  };
  render() {
    let html = '';
    if (this.props.funding)
      html = (
        <div style={wrapperStyle}>
          
          <Range
            disabled={this.props.disabled}
            min={this.props.minVal} max={this.props.maxVal}
            defaultValue={this.state.value}
            value={this.state.value}
            count={1}
            allowCross={true}
            onChange={this.setValue}
            marks={{ 1: '1M', 1000: '1B' }} handle={fundingHandle} onAfterChange={this.props.onChange} />
        </div>
      );
    if (this.props.employees)
      html = (
        <div style={wrapperStyle}>
          <Range
            disabled={this.props.disabled}
            min={this.props.minVal} max={this.props.maxVal}
            defaultValue={this.state.value}
            count={1}
            onChange={this.setValue}
            value={this.state.value} 
            marks={{ 1: '1', 500: '500' }} handle={employeeHandle} onAfterChange={this.props.onChange} />
        </div>
      )
    if (this.props.valuation)
      html = (
        <div style={wrapperStyle}>
          <Range
            disabled={this.props.disabled}
            min={this.props.minVal}
            max={this.props.maxVal} step={1000000}
            count={1}
            defaultValue={this.state.value}
            value={this.state.value} 
            onChange={this.setValue}
            marks={{ 500000000: '500M', 3000000000: '3B' }} handle={valuationHandle} onAfterChange={this.props.onChange} />
        </div>
      )
    if (this.props.growth)
      html = (
        <div style={wrapperStyle}>
          <Range
            disabled={this.props.disabled}
            min={this.props.minVal} max={this.props.maxVal}
            defaultValue={this.state.value}
            count={1}
            onChange={this.setValue}
            value={this.state.value} 
            marks={{ 0: '0%', 1000: '1000%' }} handle={growthHandle} onAfterChange={this.props.onChange} />
        </div>
      )
    if (this.props.openings)
      html = (
        <div style={wrapperStyle}>
          <Range
            disabled={this.props.disabled}
            min={this.props.minVal} max={this.props.maxVal}
            defaultValue={this.state.value}
            value={this.state.value} 
            count={1}
            onChange={this.setValue}
            marks={{ 1: '1', 75: '75' }} handle={openingsHandle} onAfterChange={this.props.onChange} />
        </div>
      )

      return (
        <React.Fragment>
        
         <div className='d-flex justify-content-between custm-form-cntrl'>
            <Input
            disabled={this.props.disabled}
            type="number"
              onChange={this.setMin}
              value={this.state.minVal} />
         

            <Input
            disabled={this.props.disabled}

              type="number"
              onChange={this.setMax}
              value={this.state.maxVal} />
         </div>
            
       
          
          {html}
        </React.Fragment>
        
        );
  }
}


// WEBPACK FOOTER //
// ./client/src/components/Aside/slider.js